module.exports = __webpack_public_path__ + "static/media/img-mobile-app-service@3x.2a3300b2.png";